import axios from 'axios'

export interface LoginCredentials {
  login: string
  password: string
}

export interface LoginResponse {
  token: string
  refreshToken: string
  user: {
    id: string
    AuthId: string
    username: string
    email: string
    roles: string[]
  }
}

export interface ApiError {
  message: string
  code: string
  status: number
}

export const authApi = {
  async login(
    credentials: LoginCredentials,
    server: string
  ): Promise<LoginResponse> {
    try {
      const response = await axios.post(
        `${server}/api/v3/auth/login`,
        credentials,
        {
          headers: {
            'Content-Type': 'application/json',
          },
          timeout: 10000,
        }
      )

      // console.log('📥 Raw server response:', response.data)
      const serverData = response.data

      if (serverData.Error) {
        throw {
          message: serverData.Error,
          code: 'AUTH_ERROR',
          status: 401,
        } as ApiError
      }

      return {
        token: serverData.AuthId,
        refreshToken: serverData.AuthId,
        user: {
          id: serverData.UserId,
          AuthId: serverData.AuthId,
          username: serverData.User,
          email: `${serverData.User}@example.com`,
          roles: ['user'],
        },
      }
    } catch (error: any) {
      if (error.response) {
        throw {
          message:
            error.response.data?.message ||
            'Логин и/или пароль введены неверно',
          code: error.response.data?.code || 'AUTH_ERROR',
          status: error.response.status,
        } as ApiError
      } else if (error.request) {
        throw {
          message: 'Сервер не отвечает',
          code: 'NETWORK_ERROR',
          status: 0,
        } as ApiError
      } else {
        throw {
          message: 'Логин и/или пароль введены неверно',
          code: 'REQUEST_ERROR',
          status: 0,
        } as ApiError
      }
    }
  },

  async logout(token: string, server: string): Promise<void> {
    try {
      await axios
        .get(`${server}/api/v3/auth/logout`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          timeout: 5000,
        })
        .catch(() => {
          console.log('ℹ️ Logout request completed (ignoring errors)')
        })
    } catch (error) {
      console.log('ℹ️ Logout: Request failed, but continuing...')
    }
  },
}
